export const aboutData = {
  title: "Who I am",
  description1:
    "Full-Stack Web Developer",
  description2:
    "Full-Stack Web Developer with the ability to learn and collaborate in rapidly changing environments and compositions worked through 1000+ hours of Bootcamp structure learning Javascript, Nodejs, Reactjs, MongoDB, Express, HTML, CSS.",
  image: 2,
};
